var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"file_name"},[_vm._v(_vm._s(_vm.file.name))]),_c('div',{staticClass:"ico",attrs:{"title":_vm.file.name}},[(_vm.notImage)?_c('i',{class:_vm.iconForType}):_c('img',{attrs:{"src":_vm.thumbUrl}})])])}
var staticRenderFns = []

export { render, staticRenderFns }